angular
  .module('shared')
  .filter 'responsiveTruncate', ->
    (text, customLimit) ->
      return text unless angular.isString(text)

      getCharLimit = ->
        return customLimit if customLimit?

        width = window.innerWidth
        switch
          when width <= 768 then 20
          when width <= 1366 then 30
          when width <= 1700 then 45
          else 75

      limit = getCharLimit()

      if text.length > limit
        text.slice(0, limit) + '…'
      else
        text
